import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { faCreditCard, faDollarSign } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-payment-options',
  templateUrl: './payment-options.component.html',
  styleUrls: ['./payment-options.component.css']
})
export class PaymentOptionsComponent implements OnInit {
  faCreditCard = faCreditCard;
  faDollarSign = faDollarSign;

  @Input() patientBalance: number;
  @Input() hasBalanceDue: boolean;

  constructor(public modal: NgbActiveModal) {}

  ngOnInit(): void {}

  selectPaymentOption(option: 'balance' | 'custom'): void {
    this.modal.close(option);
  }
}